import { deployEnv } from '@onejs/utils';
/**
 * @description: 环境枚举
 * @return {*}
 */
export enum EEnvName {
  production = 'production',
  staging = 'staging',
  test = 'test',
  /**
   * @description: 本地开发环境
   */
  development = 'development',
}
// eslint-disable-next-line import/no-mutable-exports
let curEnv = EEnvName.test;
/**
 * @description: 泳道正则, 支持ssosv|iamsrv
 */
export const cargoRegex = /(^[a-z0-9_]{1,}-[a-z]{1,}-sl-)(ssosv|iamsrv)\.it\.test\.sankuai\.com/i;
export function checkIsCargo(host = window.location.host) {
  return cargoRegex.test(host);
}
export function getCargoPrefix(host = window.location.host) {
  const resArr = host.match(cargoRegex);
  if (Array.isArray(resArr) && resArr[1]) {
    return resArr[1];
  }
  return '';
}

export const isProduction = deployEnv === 'prod';
export const isStaging = deployEnv === 'staging';
export const isTest = deployEnv === 'test';
export const isDevelopment = deployEnv === 'development';

if (isProduction) {
  curEnv = EEnvName.production;
} else if (isStaging) {
  curEnv = EEnvName.staging;
} else if (isTest || checkIsCargo()) {
  curEnv = EEnvName.test;
} else {
  curEnv = EEnvName.development;
}

export {
  curEnv,
};
